enum OriginDevice {
    ANDROID = 'android',
    IOS     = 'ios',
}

export default OriginDevice;
